// @flow
import {
  SEARCH_FEATURES_PREVIEW_FAILURE,
  SEARCH_FEATURES_PREVIEW_REQUEST,
  SEARCH_FEATURES_PREVIEW_SUCCESS,
  SearchFeaturesPreviewAction,
  SearchFeaturesPreviewState
} from 'stores/flow-type/search-preview.type';

const initialState: SearchFeaturesPreviewState = {
  features: {},
  loading: false,
  success: false,
  error: false
};
const searchPreviewReducers = (
  state: SearchFeaturesPreviewState = initialState,
  action: SearchFeaturesPreviewAction
) => {
  switch (action.type) {
    case SEARCH_FEATURES_PREVIEW_REQUEST:
      return { ...state, loading: true, success: false };
    case SEARCH_FEATURES_PREVIEW_SUCCESS: {
      return {
        ...state,
        features: action.payload.data,
        loading: false,
        success: true
      };
    }
    case SEARCH_FEATURES_PREVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        success: false
      };
    default:
      return state;
  }
};
export default searchPreviewReducers;
